<template>
  <!-- 污染物玫瑰图 -->
  <div class="curveWrapper main">
    <div  v-if="iframeURL">
      <iframe width="100%" height="320" :src="iframeURL" frameborder="0" ></iframe>
    </div>
    <div class="head" style="margin:0.12rem 0 0.24rem 0">
      <!-- 搜索区域 -->
      <div class="searchArea">
          <div class="title">查询筛选</div>
          <div class="content">
              <el-form style="width: 90%"  label-width="90px">
                  <el-row :gutter="24">
                      <el-col :span="12">
                          <el-form-item label="选择设备：">
                              <el-select v-model="quantitySelected" placeholder="请选择" size="small" @click.native="selectDevice">
                                  <el-option label="" value=""></el-option>
                              </el-select>
                          </el-form-item>
                      </el-col>
                      <el-col :span="12">
                          <el-form-item label="选择日期：">
                          <el-date-picker
                            v-model="searchParams.dateRange[1]"
                            type="datetime"
                            size="small"
                            placeholder="选择日期时间"
                            :picker-options="pickerOptions"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format=""
                            style="width:100%"
                            @change="changeDate">
                          </el-date-picker>
                          </el-form-item>
                      </el-col>
                  </el-row>
              </el-form>
              <div class="block"></div>
              <div>
                  <el-button type="primary" icon="el-icon-search" size="small" class="btnStyle" style="margin-bottom:0.1rem"  @click="searchBtnClick">查询</el-button>
              </div>
          </div>
      </div>
    </div>
      <!-- 图表 -->
    <section class="section">
      <div class="sectionSearch">
        <div class="title">
          <div>风速风向<span style="padding: 0 0.1rem;color:#ccc">|</span></div>
          <div>{{quantitySelected}}</div>
          <div v-if="isExpand" class="el-icon-caret-right" style="font-size:0.24rem" @click="isExpand = false"></div>
          <div v-if="!isExpand" class="el-icon-caret-bottom" style="font-size:0.24rem"  @click="isExpand = true"></div>
        </div>
      </div>
      <div class="expandContent"  v-if="!isExpand">
        <div class="item" v-for="(item,index) in selectedRows" :key="index">
            <div class="round" :style="{background:colorList[index]}"></div>
            <span>{{item.name}}</span>
          </div>
      </div>
      <!-- 玫瑰图 -->
      <div  class="windRose">
        <div v-for="(item,index) in selectedRows" :key="index" class="item"  :id="'myChart' + index"></div>
        <div style="width: 3.5rem; height: 0" v-for="(item,index) in selectedRows.length" :key="index +'kkk'"></div>
      </div>
    </section>
  </div>
</template>
<script>
import { getMinuteDeviceLogList } from '@/api/page/compareData.js'
import * as echarts from 'echarts'
import MixinSD from '@/store/sd/mixinsSd.js'
export default {
    mixins: [MixinSD],
    props:['paramsObject'],
    data() {
        return {
            // 搜索
            searchParams:{
              codes:[],  // 选择的设备
              dateRange:[], // 日期范围
              dateTime: ''
            },
            selectedRows:[], // 选中的设备
            quantitySelected:'',
            windList:[],
            colorList:['#D67AF0', '#FFB03A', '#5EC6FF', '#5AD8A6', '#5B8FF9', '#E25F5F', '#C6D687', '#B83B5E','#D67AF0', '#FFB03A', '#5EC6FF', '#5AD8A6', '#5B8FF9', '#E25F5F', '#C6D687'],
            windLevelText: '',
            isExpand: true,
            pickerOptions:{
              disabledDate(date) {
                return date.getTime()> Date.now();
              }
            },
            maxVal: null,
            myChart: null,
            center: {  // 经纬度
              lng: null,
              lat: null
            },
            iframeURL:''
        }
    },
    created() {
      this.getnowData()
      setInterval(()=> {
        this.getnowData()
        this.getMinuteDeviceLogList()
      },1000 *60)
      // 获取经纬度数据赋值到iframe
      let data = JSON.parse(window.localStorage.getItem('center'))
      if(data) {
        this.center.lat = parseFloat(data.lat)
        this.center.lng = parseFloat(data.lng)
      } else {
        // 若没有配置经纬度，则默认显示上海经纬度
        this.center.lat = 31.2
        this.center.lng = 121.4
      }
      this.iframeURL = "https://embed.windy.com/embed2.html?width=650&height=320&zoom=8&level=surface&overlay=wind&product=ecmwf&menu=&message=true&marker=&calendar=now&pressure=&type=map&location=coordinates&detail=&metricWind=default&metricTemp=default&radarRange=-1&lat="+ this.center.lat+ "&lon="+this.center.lng+"&detailLat="+this.center.lat+"&detailLon="+this.center.lng
    },
    beforeUnmount() {
      if (!this.myChart) {
        return
      }
      this.myChart.dispose()
      this.myChart = null
    },
    methods:{
        // 获取当前时间
       getnowData() {
         this.searchParams.dateRange[0] = this.stringTime(new Date(new Date().getTime() - (1000 * 60 * 60)))
         this.searchParams.dateRange[1] = this.stringTime(new Date())
      },
      // 查询
       searchBtnClick() {
          this.getMinuteDeviceLogList()
        },
        changeDate(val) {
          this.searchParams.dateRange[1] = this.stringTime(val)
          this.searchParams.dateRange[0] = this.stringTime(new Date(val.getTime() - (1000 * 60 * 60)))
        },
        // 选择设备
        selectDevice(val) {
            this.$emit('isShow',true)
        },
        // 风速风向图绘制
        charting() {
          let colorList = ['#D67AF0', '#FFB03A', '#5EC6FF', '#5AD8A6', '#5B8FF9', '#E25F5F', '#C6D687', '#B83B5E','#D67AF0', '#FFB03A', '#5EC6FF', '#5AD8A6', '#5B8FF9', '#E25F5F', '#C6D687', '#B83B5E']
          this.selectedRows.forEach((item,index)=> {
              var chartDom = document.getElementById('myChart' + index);
              this.myChart = echarts.init(chartDom);
              var option;
              option = {
                series: [
                  {
                    type: 'radar',
                    tooltip: {
                      trigger: 'item'
                    },
                    areaStyle: { // 单项区域填充样式
                      normal: {
                        color: colorList[index] // 填充的颜色。[ default: "#000" ]
                      }
                    },
                    data: [
                      {
                        value: this.getValue(item.code),
                        name: item.name
                      }
                    ],

                  }
                ],
                color: colorList[index],
                title: {
                  text: `{icon|} {text|${item.name}}`,
                  subtext: this.searchParams.dateRange[0].slice(10) + '~' + this.searchParams.dateRange[1].slice(10) + this.windLevelText,
                  textStyle:{
                    fontSize:12,
                    color:'#405891',
                    rich: {
                      icon: {
                        width:10,
                        height:10,
                        borderRadius: 10,
                        backgroundColor: colorList[index],
                        verticalAlign: "middle",
                      }
                    }
                  },
                  subtextStyle: {
                    fontSize:11,
                    color:'#93A6D2'
                  }
                },
                tooltip: {
                  confine: true,
                  trigger: 'axis'
                },
                radar: {
                  indicator: [
                    { name: '北',max:this.maxVal},
                    { name: '西北',max:this.maxVal},
                    { name: '西',max:this.maxVal},
                    { name: '西南',max:this.maxVal},
                    { name: '南',max:this.maxVal},
                    { name: '东南',max:this.maxVal},
                    { name: '东',max:this.maxVal},
                    { name: '东北',max:this.maxVal},
                  ],
                  center: ['50%','60%'],
                  radius: '55%',
                },
              };
              option && this.myChart.setOption(option);
              window.addEventListener("resize", () =>{
                this.myChart.resize()
              });
          })
        },
        getValue(code) {
          let dataList = []
          for(let key in this.windList) {
            if(key == code) {
              dataList = this.windList[key].list
            }
          }
          let Q = parseInt(dataList.length/6)
          let windArr = [
            dataList[0],
            dataList[Q],
            dataList[Q*2],
            dataList[Q*3],
            dataList[Q*4],
            dataList[Q*5]
          ]
          if(windArr[0] !==undefined) {
              let list = [0,0,0,0,0,0,0,0]
              // 获取一个小时内6个点位的最大值来判断风向
              let first = windArr[0].WS
              let maxValue = windArr[0]
              for (let i = 0; i < windArr.length; i++) {
                if (windArr[i].WS>first) {
                  first = windArr[i].WS;
                  maxValue = windArr[i]
                }
              }
              this.maxVal = maxValue.WS
              // 判断获取的6个点位各属于哪个方向(若同一个方向有多个值，取最大值)
              let arr1 = []
              let arr2 = []
              let arr3 = []
              let arr4 = []
              let arr5 = []
              let arr6 = []
              let arr7 = []
              let arr8 = []
              windArr.forEach((item,i)=> {
                if(item.WD>337.5 || item.WD<=22.5) {
                  arr1.push(item.WS)
                  let maxWS = Math.max(...arr1)
                  list[0]= maxWS
                }else if(item.WD >22.5 && item.WD <= 67.5) {
                  arr2.push(item.WS)
                  let maxWS = Math.max(...arr2)
                  list[7]= maxWS
                } else if(item.WD>67.5 && item.WD <= 112.5) {
                  arr3.push(item.WS)
                  let maxWS = Math.max(...arr3)
                  list[6]=maxWS
                } else if(item.WD>112.5 && item.WD <= 157.5) {
                  arr4.push(item.WS)
                  let maxWS = Math.max(...arr4)
                  list[5]=maxWS
                } else if(item.WD>157.5 && item.WD <= 202.5) {
                  arr5.push(item.WS)
                  let maxWS = Math.max(...arr5)
                  list[4]=maxWS
                } else if(item.WD>202.5 && item.WD <= 247.5) {
                  arr6.push(item.WS)
                  let maxWS = Math.max(...arr6)
                  list[3]= maxWS
                } else if(item.WD>247.5 && item.WD <=292.5) {
                  arr7.push(item.WS)
                  let maxWS = Math.max(...arr7)
                  list[2]=maxWS
                } else if(item.WD>292.5 && item.WD <= 337.5) {
                  arr8.push(item.WS)
                  let maxWS = Math.max(...arr8)
                  list[1]=maxWS
                }
              })
              if(maxValue.WD>337.5 || maxValue.WD<=22.5) {
                   this.windLevelText = '\xa0\xa0'+'偏北风'+ '\xa0\xa0'+ this.getwindSpeed(maxValue.WS) +'\xa0\xa0'+ maxValue.WS +'m/s'
                }else if(maxValue.WD >22.5 && maxValue.WD <= 67.5) {
                  this.windLevelText = '\xa0\xa0'+'偏东北风' +'\xa0\xa0'+this.getwindSpeed(maxValue.WS) +'\xa0\xa0'+ maxValue.WS +'m/s'
                } else if(maxValue.WD>67.5 && maxValue.WD <= 112.5) {
                  this.windLevelText = '\xa0\xa0'+'偏东风'+'\xa0\xa0'+this.getwindSpeed(maxValue.WS) +'\xa0\xa0'+ maxValue.WS +'m/s'
                } else if(maxValue.WD>112.5 && maxValue.WD <= 157.5) {
                  this.windLevelText = '\xa0\xa0'+'偏东南风'+'\xa0\xa0'+this.getwindSpeed(maxValue.WS) +'\xa0\xa0'+ maxValue.WS +'m/s'
                } else if(maxValue.WD>157.5 && maxValue.WD <= 202.5) {
                  this.windLevelText = '\xa0\xa0'+'偏南风'+'\xa0\xa0'+this.getwindSpeed(maxValue.WS) + '\xa0\xa0'+maxValue.WS +'m/s'
                } else if(maxValue.WD>202.5 && maxValue.WD <= 247.5) {
                  this.windLevelText = '\xa0\xa0'+'偏西南风'+'\xa0\xa0'+this.getwindSpeed(maxValue.WS) +'\xa0\xa0'+ maxValue.WS +'m/s'
                } else if(maxValue.WD>247.5 && maxValue.WD <=292.5) {
                  this.windLevelText = '\xa0\xa0'+'偏西风'+'\xa0\xa0'+this.getwindSpeed(maxValue.WS) + '\xa0\xa0'+maxValue.WS +'m/s'
                } else if(maxValue.WD>292.5 && maxValue.WD <= 337.5) {
                  this.windLevelText = '\xa0\xa0'+'偏西北风'+'\xa0\xa0'+this.getwindSpeed(maxValue.WS) +'\xa0\xa0'+ maxValue.WS +'m/s'
                }
              return list
          }
        },
        // 获取风力等级
        getwindSpeed(val) {
          if(val>=0 && val<=0.2) {
            return '0级'
          } else if(val>=0.3 && val<= 1.5) {
            return '1级'
          }else if(val>=1.6 && val<= 3.3) {
            return '2级'
          }else if(val>=3.4 && val<= 5.4) {
            return '3级'
          }else if(val>=5.5 && val<= 7.9) {
            return '4级'
          }else if(val>=8.0 && val<= 10.7) {
            return '5级'
          }else if(val>=10.8 && val<= 13.8) {
            return '6级'
          }else if(val>=13.9&& val<= 17.1) {
            return '7级'
          }else if(val>=17.2 && val<= 20.7) {
            return '8级'
          }else if(val>=20.8 && val<= 24.4) {
            return '9级'
          }else if(val>=24.5 && val<= 28.4) {
            return '10级'
          }else if(val>=28.5 && val<= 32.6) {
            return '11级'
          }else if(val>32.7) {
            return '12级'
          }
        },
        // 获取分钟值
        getMinuteDeviceLogList() {
          let params = {
            account: window.localStorage.getItem('account'),
            token: window.localStorage.getItem('token'),
            ts:this.stringTime(new Date()),
            codes: this.searchParams.codes.join(','),
            max_time:this.searchParams.dateRange[1],
            min_time:this.searchParams.dateRange[0],
            limit: 60,
            params: 'WD,WS',
          }
          getMinuteDeviceLogList(params).then(res=> {
            this.windList  = res.data
            this.charting()
          })
        }

    },
    watch: {
        paramsObject: {
            handler: function(value) {
                const that = this
                if(value) {
                this.quantitySelected = '已选择'+ value.length + '台设备'
                const result = JSON.parse(JSON.stringify(value))
                this.selectedRows = result
                this.selectedRows.forEach(item=> {
                  this.searchParams.codes.push(item.code)
                })
                this.getMinuteDeviceLogList()
                setTimeout(function () {
                    that .searchBtnClick() // 查询
                }, 200)
                }
            }
        }
    }

}
</script>
<style scoped lang="less">
.main {
  margin: 0.08rem 0.24rem 0.24rem 0.24rem;
}
.section {
  padding: 0.24rem;
  .sectionSearch {
    .title {
      display: flex;
      align-items: center;
      font-size: 0.16rem;
      color:#405891;
      font-weight: bold;
    }
  }
}
::v-deep .el-select {
    width: 100%;
}
::v-deep .el-form-item {
  margin-bottom: 0.1rem;
  .el-form-item__label {
      color: #405891;
  }
}
::v-deep .el-range-editor--small.el-input__inner {
  width: 100%;
}
.windRose {
  display:flex;
  flex-wrap:wrap;
  justify-content:space-between;
  .item {
    padding: 10px;
    border:1px solid #DEE4F1;
    width:3.5rem;
    height:4rem;
    border-radius:8px;
    margin-bottom: 20px;
  }
}
.expandContent {
  color: #405891;
  padding: 0 0.24rem 0.24rem 0.24rem;
  margin-bottom: 0.1rem;
  display: flex;
  flex-wrap: wrap;
  .item {
    margin-right: 0.25rem;
    margin-bottom: 0.1rem;
    .round {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      display: inline-block;
      margin-right: 10px;
    }
  }
}
.block::after {
  height: 0.3rem;
}
</style>
